import { FormCheck, InputGroup, Modal } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import React, {useState} from "react";
import { useHouseDispatch, useHouseState } from "../../contexts/HouseContext";

export const AddPlayerModal = ({ gameId, players, show, handleClose }) => {
    const [mode, updateMode] = useState("editPlayers")
    const toggleMode = () => {
        updateMode(mode === "editPlayers" ? "addMember" : "editPlayers")
    }
    const activatePlayerMode = () => updateMode("editPlayers")
    const isPlayerMode = mode === "editPlayers";

    return (
        <Modal backdrop='static' show={show} onHide={handleClose} scrollable={true}>
            <Modal.Header className="justify-content-between">
                {isPlayerMode
                    ? <span>Select players for this game</span>
                    : <span>Create a new member</span>
                }
                <Button
                    variant="success"
                    onClick={toggleMode}>
                    {isPlayerMode ? "Add Member" : "Cancel"}
                </Button>
            </Modal.Header>
            <Modal.Body>
                {isPlayerMode
                    ? <EditPlayersForm
                        players={players}
                        gameId={gameId}
                        handleClose={handleClose} />
                    : <AddMemberForm
                        gameId={gameId}
                        postSubmitHook={activatePlayerMode}
                    />
                }
            </Modal.Body>
            {isPlayerMode ? (
                <Modal.Footer>
                    <Button onClick={handleClose}>Done</Button>
                </Modal.Footer>
            ) : null}
        </Modal>
    );
};

const EditPlayersForm = ({ gameId, players }) => {
    const { addPlayer, removePlayer } = useHouseDispatch();
    const { house } = useHouseState();

    const handleChange = async (e) => {
        const check = e.target;
        const memberId = check.value;
        const chosen = check.checked;

        if (chosen) {
            await addPlayer(gameId, memberId)
        } else {
            await removePlayer(gameId, memberId)
        }
    };

    const memberChecks = house.members.map((m, i) => {
        let playerId = m.id;
        let isMemberPlayer = false;
        let isDisabled = false;

        const player = players.find(p => p.memberId === m.id)

        if (player !== undefined) {
            isMemberPlayer = true;
            isDisabled = player.transactions.length > 0
            playerId = player.id
        }

        return (<FormCheck
            type="switch"
            key={i}
            disabled={isDisabled}
            value={`${playerId}`}
            label={m.name}
            checked={isMemberPlayer}
            onChange={handleChange}
        />);
    });
    return (
       <Form>
           <Row className="justify-content-between">
               <Col xs={12} className="v-scrollable">
                   <Form.Group>
                       {memberChecks}
                   </Form.Group>
               </Col>
           </Row>
       </Form>
   )
};

const AddMemberForm = ({ gameId, postSubmitHook }) => {
    const { addMember, addPlayer } = useHouseDispatch();
    const [error, setError] = useState(null);
    const onSubmit = async (e) => {
        e.preventDefault();
        const form = e.target
        const nameInput = form.elements.name;
        try {
            const newMember = await addMember(nameInput.value);
            addPlayer(gameId, newMember.id);
            postSubmitHook();
        } catch (e) {
            setError(e.message)
        }
    }
    return (
        <Form onSubmit={onSubmit}>
            <Row>
                <InputGroup>
                    <Col xs={9}>
                        <Form.Control
                            required={true}
                            name="name"
                            placeholder="Member name..."
                            className="mb-2"
                        />
                        {error ? <span className="text-danger ms-1">{error}</span> : null}
                    </Col>
                    <Col xs="auto">
                        <Button type="submit">Submit</Button>
                    </Col>
                </InputGroup>
            </Row>
    </Form>);
}
